import { api } from 'app/api/client';
import { UserRoutes } from 'app/_modules/user/api/routes';
import { TMeResponse } from 'app/auth/types';
import { TLegalContentResponse } from '../types/userTypes';
import { IPatientFormData, IEmergencyContact, IPatientData } from '../types/userFormTypes';

const userApi = {
  getMe(): Promise<TMeResponse> {
    return api.get<TMeResponse>(UserRoutes.users.me());
  },
  getPatientData(): Promise<IPatientData> {
    return api.get<IPatientData>(UserRoutes.users.patientData());
  },
  getLegalContent(orgId : string, type: string): Promise<TLegalContentResponse> {
    return api.get<TLegalContentResponse>(UserRoutes.docs.legalContent(orgId, type));
  },
  getPatientInformation(userId: string): Promise<any> {
    return api.get<any>(UserRoutes.patients.details(userId));
  },
  updatePatientInformation(patientId: string, data: IPatientFormData): Promise<any> {
    return api.put<any>(UserRoutes.patients.updatePatientInformation(patientId), data);
  },
  updatePatientEmergencyContact(patientId: string, data: IEmergencyContact): Promise<any> {
    return api.put<any>(UserRoutes.patients.updateEmergencyContact(patientId), data);
  }
};

export { userApi };